module.exports = __webpack_public_path__ + "static/media/user-plus.0f3c75c4.svg";